export default __webpack_public_path__ + "static/media/people.53e86cae.png";